import * as React from "react";
import {api} from "../../../api";
import {AsyncSelect} from "./AsyncSelect";


export class SenatorialDistrictPicker extends React.Component<any> {
    constructor(props: any) {
        super(props);
    }

    loadOptions = (inputValue: string, callback: any) => {
        const filters = this.props.filters;
        // TODO min length, limit results in API
        api.senatorialDistrict.getListAction({
            page: 0,
            search: inputValue,
            filters: filters
        }).then((response) => {
            callback(response.map((item: any) => ({
                value: item['id'],
                //TODO we need label direct from endpoint, that will also be used to fill values while editing
                label: item['name'] + ' (' + item['code'] + '), ' + item['state']['name'],
                id: item['id'],
            })));
        });
    };

    render() {
        const {...rest} = this.props;

        return (
            <AsyncSelect
                multi={true}
                cacheOptions={true}
                loadOptions={this.loadOptions}
                placeholder="Search senatorial district ..."
                {...rest}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/form/fields/SenatorialDistrictPicker.tsx